export default "__VITE_PUBLIC_ASSET__f5af86c7__"